import { routes } from '../config/api_routes'

export const generalSettingService = {

    // get all delivery zone
    getAllGeneralSettings: () => window.axios.get(routes.getAllGeneralSettingsApi),
    updateGeneralSetting: (data) => window.axios.post(routes.updateGeneralSettingApi, data),
   
}